import { render } from "./RealtimeUploadSuccessCard.vue?vue&type=template&id=2813ae14&ts=true"
import script from "./RealtimeUploadSuccessCard.vue?vue&type=script&lang=ts"
export * from "./RealtimeUploadSuccessCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__